import React, {useEffect, useContext} from "react";
import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import {RouterContext} from "./Onboarding"

export default function NextButton(props) {
  const route = useContext(RouterContext)

  let chevronRight = require("images/onboarding/chevronRight.png");
  chevronRight = <img style={{paddingBottom:"2px", paddingLeft: "12px"}} src={`/datapulse${chevronRight}`} />;

  return (
    <>
      {props.validated ? (
        <>
          <Button
            className={`py-0 f16 btn-lg nunito-regular nextBtn validated ${props.className ? props.className : undefined}`}
            size="md"
            onClick={() => {
              route.set((prev) => [...prev, window.location.pathname]);
              if (props.onClick) { 
                props.onClick();
                // Need to delay submitForm since onClick updates client account and saves can overlap
                setTimeout(() => props.submitForm(props.nextPage), 1000);
              } else {
                props.submitForm(props.nextPage);
              }
              
            }}
          >
            {props.btnText}{chevronRight}
          </Button>
        </>
      ) : (
        <OverlayTrigger
          trigger={["hover", "focus"]}
          key={"top"}
          placement={"top"}
          overlay={
            <Popover id={`popover-positioned-top`}>
              <p className="text-center">{props.invalidText}</p>
            </Popover>
          }>
          <Button style={{cursor: "default"}} className={`py-0 f16 nunito-regular nextBtn unvalidated disabled-color ${props.className ? props.className : undefined}`} size="md">
           {props.btnText}{chevronRight}
          </Button>
        </OverlayTrigger>
      )}
    </>
  );
}





